import React from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/amazonSlice";
import StarIcon from "@mui/icons-material/Star";

const ProductDetail = ({ product, onClose }) => {
  const dispatch = useDispatch();

  // Function to add the product to the cart
  const handleAddToCart = () => {
    // Dispatch the addToCart action with the product data
    dispatch(
      addToCart({
        _id: product._id,
        id: product.id,
        title: product.title,
        description: product.description,
        price: product.price,
        category: product.category,
        image: product.image,
        quantity: 1,
      })
    );

    // Close the product detail modal
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 mt-12">
      <div className="bg-white p-4 md:p-8 rounded-lg shadow-lg relative flex flex-col md:flex-row items-center w-full md:w-[80%] h-auto md:h-[70%] max-h-[600px]">
        {/* Left side (Image) */}
        <div className="w-full md:w-2/5">
          <img
            src={product.image}
            alt={product.title}
            className="w-full h-52 md:h-72 object-cover rounded-md"
          />
        </div>

        {/* Right side (Product Details) */}
        <div className="w-full md:w-3/5 md:pl-4 mt-4 md:mt-0">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 bg-gray-200 px-2 rounded-full text-black text-lg"
          >
            X
          </button>
          <h2 className="text-2xl font-semibold mb-2">{product.title}</h2>
          <p className="text-gray-500">{product.description}</p>
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center">
              <p className="text-xl font-semibold text-blue-900">
                ${product.price}
              </p>
              <div className="ml-2 flex items-center">
                <StarIcon className="text-yellow-500" />
                <p className="text-gray-500 ml-1">
                  {product.rating.rate} ({product.rating.count} reviews)
                </p>
              </div>
            </div>
            <button
              onClick={handleAddToCart}
              className="px-4 py-2 bg-blue-950 text-white font-medium rounded-md hover:bg-blue-900 focus:outline-none"
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
